import { MODULE_NAME } from '../moduleName';
import {
 PagedResponse,
 QueryParams,
 PagedResponseEmpty,
} from '@ofqual/portal-core/core/types';
import { OfqualNotification } from '../services/domain/OfqualNotification';

export interface NotificationsDataState {
 params: QueryParams;
 response: PagedResponse<OfqualNotification>;
 status: 'NOT_LOADED' | 'LOADING' | 'LOADED';
 hasData: boolean;
}

export const defaultDataState: NotificationsDataState = {
 params: {},
 status: 'NOT_LOADED',
 response: PagedResponseEmpty,
 hasData: false,
};

export interface NotificationsViewState {
 isOpen: boolean;
 isBulkMode: boolean;
 notificationsToClear: string[];
}

export const defaultViewState: NotificationsViewState = {
 isOpen: false,
 isBulkMode: false,
 notificationsToClear: [],
};

interface ModuleState {
 // other state areas for this module....
 dataState: NotificationsDataState;
 viewState: NotificationsViewState;
}

export enum UserType {
 Unknown = 0,
 Ofqual = 1,
 CCEA = 2,
 AO = 3,
}

// if there is any state from other modules that we use in this module
//  we have an opportunity to at least type it for ourselves
export interface RemoteState {
 auth: {
  user: {
   upn: string;
   displayName: string;
   token: string;
   roles: number[];
   userType: UserType;
   org: {
    id: number;
    name: string;
   };
  };
 };
}

export interface GlobalState extends RemoteState {
 [MODULE_NAME]: ModuleState;
}
